
/*  TWO COLUMNS ( https://tailwindui.com/components/marketing/sections/content-sections#component-176f404f597838293fd652b71bf0726f )  */

import React from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import { TitleColour } from '/src/utils/ColourUtilities'
import LinkStyle from 'src/utils/LinkStyle'

const TwoColumns = ({ blok }) => {

    const Heading = ({children}) => {
        return blok.content_type === 'magazine' ?
        <h2 className={`font-insights-display text-lg leading-5 font-semibold mb-2`} style={{color: blok.primary_colour}}>{children}</h2> :
        <h2 className={`font-display uppercase sm:text-2xl text-xl sm:!leading-6 !leading-4 mb-2 ${TitleColour(blok.colour)}`}>{children}</h2>
    }

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="bg-white">
                <div className="my-16 xl:my-24 px-6 lg:px-8 max-w-7xl mx-auto">
                    <div className="max-w-max lg:max-w-7xl mx-auto">
                        <div className="lg:grid lg:grid-cols-2 lg:gap-6">
                            <Heading>{blok.title}</Heading>
                            <Heading>{blok.title_right}</Heading>
                        </div>
                        <div className="relative">
                            <div className="relative md:bg-white">
                                <div className="lg:grid lg:grid-cols-2 lg:gap-6">
                                    <div className={`text-sm text-darkgrey prose max-w-full ${blok.content_type === 'magazine' ? "font-insights-body" : "font-body"}`}>
                                        <RichText>{blok.content_left}</RichText>
                                    </div>
                                    <div className={`text-sm text-darkgrey prose prose-${blok._uid} max-w-full ${blok.content_type === 'magazine' ? "font-insights-body" : "font-body"}`}>
                                        <RichText>{blok.content_right}</RichText>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <LinkStyle {...blok}/>
        </SbEditable>
    )
}

export default TwoColumns